import { useEffect, useState } from 'react'
import { Table, InputGroup, FormControl, Badge } from 'react-bootstrap'
import Container from '@material-ui/core/Container'
import Alert from '@material-ui/lab/Alert'
import history from '../../history'

import api from '../../services/api'

import '../Main/Main.css'
import NavBar from '../../components/NavBar/NavBar.js'
import { Paper } from '@material-ui/core'

function MainDashboard() {
  const [empresas, setEmpresas] = useState([])
  const [search, setSearch] = useState('')
  useEffect(() => {
    ; (async () => {
      api.get('/empresas?ativa=1').then((response) => {
        const result = response.data
        const Storage = localStorage.setItem('empresas', JSON.stringify(result))
        setEmpresas(result)
      })
    })()
  }, [])
  function refreshPage(info) {
    window.location.reload(info)
  }

  const filteredChamados = empresas.filter((empresa) => {
    return empresa.name.toLowerCase().includes(search.toLocaleLowerCase())
  })

  return (
    <NavBar >
      <div>
        <div>
          <Container component={Paper} maxWidth='xl'>
            <br />
            <InputGroup className="mb-3">
              <FormControl
                placeholder="Pesquisar por nome do cliente"
                aria-label="Pesquisar por nome do cliente"
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value)
                }}
              />
            </InputGroup>
            <Table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Tipo contrato</th>
                  <th>Pacote de Minutos</th>
                </tr>
              </thead>
              {filteredChamados
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((empresas) => {
                  let statusHoras = 'success'
                  let statusMsg = `O pacote de horas atual é `
                  if (empresas.contrato === 'Contrato') {
                    statusMsg = 'Empresa de contrato'
                    statusHoras = 'success'
                  } else if (!empresas.pacote_horas) {
                    statusMsg = 'Sem um pacote de horas cadastrado'
                    statusHoras = 'warning'
                  } else if (empresas.pacote_horas <= 60) {
                    statusHoras = 'error'
                    statusMsg = 'Alerta, pacote de minutos: '
                  }
                  function openEmpresa() {
                    localStorage.setItem('idEmpresa', empresas._id)
                    history.push('/Gestao/empresas/edit')
                    refreshPage()
                  }
                  return (
                    <tbody>
                      <tr onClick={openEmpresa}>
                        <td>{empresas.name}</td>
                        <td>{empresas.contrato}</td>
                        <td>
                          <Alert variant="filled" severity={statusHoras}>
                            {statusMsg} {empresas.pacote_horas}
                          </Alert>
                        </td>
                      </tr>
                    </tbody>
                  )
                })}
            </Table>
            <br />
          </Container>
          <br />
        </div>
      </div>
    </NavBar>
  )
}

export default MainDashboard
